module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container edit-user-template"
  }, [_c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [(_vm.canEditDetails) ? [_vm._v("\n        Edit user details:\n      ")] : (_vm.canEditPassword) ? [_vm._v("\n        Edit user password:\n      ")] : [_vm._v("\n        User profile:\n      ")], _vm._v("\n      " + _vm._s(_vm.user.personal.first_name) + " " + _vm._s(_vm.user.personal.last_name) + "\n    ")], 2), _vm._v(" "), _c('div', {
    staticClass: "profile-actions"
  }, [(this.user.personal.status !== 5) ? [_c('button', {
    staticClass: "archive-profile archive-profile-custom background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.archiveProfile()
      }
    }
  }, [_c('span', {
    staticClass: "delete-profile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 11.207 14.009"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 11.207 14.009",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_14_",
      "d": "M9.806,0H1.401C0.628,0,0,0.628,0,1.401v11.207c0,0.772,0.628,1.401,1.401,1.401h8.405\n                c0.773,0,1.401-0.629,1.401-1.401V1.401C11.207,0.628,10.579,0,9.806,0z M9.094,5.697H6.946v2.148h2.148v2.148H6.946V7.845H4.798\n                V5.697h2.148V3.549H4.798V1.401h2.148v2.148h2.148V5.697z"
    }
  })])]), _vm._v(" "), (this.user.personal.enabled) ? [_vm._v("\n            Archive\n          ")] : [_vm._v("\n            Unarchive\n          ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "delete-profile delete-profile-custom background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteProfile()
      }
    }
  }, [_c('span', {
    staticClass: "delete-profile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 14.431 15.232"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 14.431 15.232",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_8_",
      "points": "9.62,1.603 9.62,0 4.81,0 4.81,1.603 0,1.603 0,3.207 14.431,3.207 14.431,1.603 "
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_7_",
      "d": "M1.603,4.008v9.621c0,0.884,0.719,1.603,1.603,1.603h8.017c0.884,0,1.603-0.72,1.603-1.603V4.008\n                H1.603z M6.414,12.026H4.81v-4.81h1.603V12.026z M9.62,12.026H8.017v-4.81H9.62V12.026z"
    }
  })])]), _vm._v("\n          Delete\n        ")])] : _vm._e(), _vm._v(" "), (this.user.personal.status === 5) ? [_c('button', {
    staticClass: "delete-profile delete-profile-custom background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.approveUser(true)
      }
    }
  }, [_c('span', {
    staticClass: "delete-profile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 174.239 174.239"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 174.239 174.239",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M87.12,0C39.082,0,0,39.082,0,87.12s39.082,87.12,87.12,87.12s87.12-39.082,87.12-87.12S135.157,0,87.12,0z M87.12,159.305\n                  c-39.802,0-72.185-32.383-72.185-72.185S47.318,14.935,87.12,14.935s72.185,32.383,72.185,72.185S126.921,159.305,87.12,159.305z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M131.55,59.413c-3.231-2.562-7.927-2.027-10.491,1.211L86.694,103.95L66.132,82.015c-2.812-3.014-7.543-3.155-10.555-0.345\n                  c-3.009,2.825-3.162,7.55-0.34,10.555l26.481,28.251c1.415,1.512,3.389,2.363,5.447,2.363c0.102,0,0.204,0,0.309-0.005\n                  c2.168-0.092,4.193-1.123,5.542-2.825L132.76,69.9C135.322,66.672,134.78,61.976,131.55,59.413z"
    }
  })])])]), _vm._v("\n          Approve\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "delete-profile delete-profile-custom background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.approveUser(false)
      }
    }
  }, [_c('span', {
    staticClass: "delete-profile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 174.239 174.239"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 174.239 174.239",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M87.12,0C39.082,0,0,39.082,0,87.12s39.082,87.12,87.12,87.12s87.12-39.082,87.12-87.12S135.157,0,87.12,0z M87.12,159.305\n                  c-39.802,0-72.185-32.383-72.185-72.185S47.318,14.935,87.12,14.935s72.185,32.383,72.185,72.185S126.921,159.305,87.12,159.305z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M120.83,53.414c-2.917-2.917-7.647-2.917-10.559,0L87.12,76.568L63.969,53.414c-2.917-2.917-7.642-2.917-10.559,0\n                  s-2.917,7.642,0,10.559l23.151,23.153L53.409,110.28c-2.917,2.917-2.917,7.642,0,10.559c1.458,1.458,3.369,2.188,5.28,2.188\n                  c1.911,0,3.824-0.729,5.28-2.188L87.12,97.686l23.151,23.153c1.458,1.458,3.369,2.188,5.28,2.188c1.911,0,3.821-0.729,5.28-2.188\n                  c2.917-2.917,2.917-7.642,0-10.559L97.679,87.127l23.151-23.153C123.747,61.057,123.747,56.331,120.83,53.414z"
    }
  })])])]), _vm._v("\n          Reject\n        ")])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard dashboard-custom background-1-20 color-2-100",
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "dashboard-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M501.333,490.667H10.667C4.779,490.667,0,495.445,0,501.333C0,507.221,4.779,512,10.667,512h490.667\n                  c5.888,0,10.667-4.779,10.667-10.667C512,495.445,507.221,490.667,501.333,490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M96,362.667H32c-5.888,0-10.667,4.779-10.667,10.667v128C21.333,507.221,26.112,512,32,512h64\n                  c5.888,0,10.667-4.779,10.667-10.667v-128C106.667,367.445,101.888,362.667,96,362.667z M85.333,490.667H42.667V384h42.667\n                  V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M224,256h-64c-5.888,0-10.667,4.779-10.667,10.667v234.667c0,5.888,4.779,10.667,10.667,10.667h64\n                  c5.888,0,10.667-4.779,10.667-10.667V266.667C234.667,260.779,229.888,256,224,256z M213.333,490.667h-42.667V277.333h42.667\n                  V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M352,298.667h-64c-5.888,0-10.667,4.779-10.667,10.667v192c0,5.888,4.779,10.667,10.667,10.667h64\n                  c5.888,0,10.667-4.779,10.667-10.667v-192C362.667,303.445,357.888,298.667,352,298.667z M341.333,490.667h-42.667V320h42.667\n                  V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M480,170.667h-64c-5.888,0-10.667,4.779-10.667,10.667v320c0,5.888,4.779,10.667,10.667,10.667h64\n                  c5.888,0,10.667-4.779,10.667-10.667v-320C490.667,175.445,485.888,170.667,480,170.667z M469.333,490.667h-42.667V192h42.667\n                  V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M64,192c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667\n                  c23.531,0,42.667-19.136,42.667-42.667C106.667,211.136,87.531,192,64,192z M64,256c-11.776,0-21.333-9.579-21.333-21.333\n                  c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C85.333,246.421,75.776,256,64,256z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M192,85.333c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667s42.667-19.136,42.667-42.667\n                  C234.667,104.469,215.531,85.333,192,85.333z M192,149.333c-11.776,0-21.333-9.579-21.333-21.333\n                  c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C213.333,139.755,203.776,149.333,192,149.333z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M320,128c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667\n                  c23.531,0,42.667-19.136,42.667-42.667C362.667,147.136,343.531,128,320,128z M320,192c-11.776,0-21.333-9.579-21.333-21.333\n                  c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C341.333,182.421,331.776,192,320,192z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M448,0c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667\n                  c23.531,0,42.667-19.136,42.667-42.667C490.667,19.136,471.531,0,448,0z M448,64c-11.776,0-21.333-9.579-21.333-21.333\n                  c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C469.333,54.421,459.776,64,448,64z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M432.939,57.728c-4.16-4.16-10.923-4.16-15.083,0l-82.773,82.773c-4.16,4.16-4.16,10.923,0,15.083\n                  c2.091,2.069,4.821,3.115,7.552,3.115c2.709,0,5.44-1.024,7.531-3.115l82.773-82.773\n                  C437.099,68.651,437.099,61.888,432.939,57.728z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M294.208,146.048l-68.523-19.541c-5.739-1.664-11.563,1.664-13.163,7.339c-1.621,5.675,1.664,11.563,7.317,13.184\n                  l68.523,19.541c0.981,0.277,1.963,0.405,2.923,0.405c4.651,0,8.917-3.051,10.261-7.744\n                  C303.168,153.579,299.883,147.669,294.208,146.048z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M175.36,141.291c-3.669-4.608-10.368-5.355-14.976-1.707l-80.427,64.128c-4.608,3.691-5.376,10.389-1.685,14.997\n                  c2.112,2.645,5.227,4.011,8.341,4.011c2.325,0,4.672-0.768,6.635-2.304l80.427-64.128\n                  C178.283,152.597,179.051,145.899,175.36,141.291z"
    }
  })])])])]), _vm._v("\n      Go to Dashboard\n    ")]), _vm._v(" "), (_vm.getUserRole !== 'cu' && _vm.user.personal.company) ? _c('router-link', {
    staticClass: "all-users all-users-custom background-1-20 color-2-100",
    attrs: {
      "to": {
        name: _vm.getUserRole === 'gm' ? 'users' : 'ca-users'
      }
    }
  }, [_c('span', {
    staticClass: "all-users-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 32.053 34.5"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32.053 34.5",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_10_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_20_",
      "d": "M4.75,0C2.131,0,0,2.131,0,4.75S2.131,9.5,4.75,9.5S9.5,7.369,9.5,4.75S7.369,0,4.75,0z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_21_",
      "d": "M15.178,6.25h15.375c0.829,0,1.5-0.671,1.5-1.5s-0.671-1.5-1.5-1.5H15.178\n                c-0.829,0-1.5,0.671-1.5,1.5S14.349,6.25,15.178,6.25z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_22_",
      "d": "M4.75,12.375c-2.619,0-4.75,2.131-4.75,4.75s2.131,4.75,4.75,4.75s4.75-2.131,4.75-4.75\n                S7.369,12.375,4.75,12.375z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_23_",
      "d": "M30.553,15.625H15.178c-0.829,0-1.5,0.671-1.5,1.5s0.671,1.5,1.5,1.5h15.375\n                c0.829,0,1.5-0.671,1.5-1.5S31.381,15.625,30.553,15.625z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_24_",
      "d": "M4.75,25C2.131,25,0,27.131,0,29.75s2.131,4.75,4.75,4.75s4.75-2.131,4.75-4.75\n                S7.369,25,4.75,25z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_25_",
      "d": "M30.553,28.25H15.178c-0.829,0-1.5,0.671-1.5,1.5s0.671,1.5,1.5,1.5h15.375\n                c0.829,0,1.5-0.671,1.5-1.5S31.381,28.25,30.553,28.25z"
    }
  })])])]), _vm._v("\n      Back to all users\n    ")]) : _vm._e(), _vm._v(" "), (_vm.getUserRole === 'gm' && (this.user.personal.role && this.user.personal.role.slug !== 'gm')) ? _c('button', {
    staticClass: "impersonate-user background-1-20",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.impersonateUser()
      }
    }
  }, [_vm._v("Impersonate this user")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 details color-1-100",
    class: [{
      'active  color-1-100': _vm.activeSection === 'userDetails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('userDetails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 18"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 18",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_1_",
      "d": "M18,2h-5.185C12.401,0.838,11.302,0,10,0S7.599,0.838,7.185,2H2C0.897,2,0,2.897,0,4v12\n                    c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V4C20,2.897,19.103,2,18,2z M6,6c1.105,0,2,0.896,2,2s-0.895,2-2,2S4,9.104,4,8\n                    S4.895,6,6,6z M3,14c0-1.841,1.159-3,3-3c1.841,0,3,1.159,3,3H3z M10,4C9.449,4,9,3.551,9,3c0-0.551,0.449-1,1-1s1,0.449,1,1\n                    C11,3.551,10.551,4,10,4z M17,14h-6v-2h6V14z M17,10h-6V8h6V10z"
    }
  })])]), _vm._v(" "), (_vm.canEditDetails === false) ? [_vm._v("User details")] : [_vm._v("Edit user details")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 password",
    class: [{
      'active  color-1-100': _vm.activeSection === 'userPassword'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('userPassword')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 20"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_1_",
      "d": "M10,0C4.477,0,0,4.477,0,10s4.477,10,10,10c5.523,0,10-4.477,10-10S15.523,0,10,0z M11.378,10.65\n                    L12,15H8l0.622-4.35C7.662,10.149,7,9.157,7,8c0-1.656,1.344-3,3-3c1.656,0,3,1.344,3,3C13,9.157,12.338,10.149,11.378,10.65z"
    }
  })])]), _vm._v(" "), (_vm.canEditPassword === false) ? [_vm._v("User password")] : [_vm._v("Edit user password")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 data",
    class: [{
      'active  color-1-100': _vm.activeSection === 'userData'
    }]
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 19.99 21"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 19.99 21",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M11,14H9c-2.757,0-5,2.239-5,4.996V21h12v-2.004C16,16.239,13.756,14,11,14z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M6.343,12.523c-1.249-1.757-1.099-4.21,0.475-5.784c1.754-1.755,4.609-1.755,6.364,0\n                    c1.574,1.573,1.724,4.027,0.475,5.784c0.629,0.259,1.212,0.608,1.733,1.028c1.702-2.526,1.439-5.992-0.793-8.226\n                    c-2.534-2.535-6.658-2.533-9.193,0c-2.232,2.234-2.495,5.7-0.793,8.226C5.131,13.13,5.714,12.781,6.343,12.523z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M3.512,14.663C2.535,13.31,2,11.697,2,9.995c0-2.137,0.832-4.146,2.343-5.657\n                    c3.119-3.119,8.194-3.119,11.313,0c2.809,2.81,3.08,7.2,0.83,10.324c0.445,0.563,0.803,1.194,1.06,1.878\n                    c3.406-3.923,3.254-9.886-0.476-13.617c-3.898-3.897-10.243-3.897-14.142,0C1.041,4.812,0,7.325,0,9.995\n                    c0,2.434,0.872,4.729,2.452,6.546C2.709,15.858,3.067,15.226,3.512,14.663z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "10",
      "cy": "9.995",
      "r": "3"
    }
  })])])]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('userData')
      }
    }
  }, [_vm._v("User Data")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "userDetails",
    staticClass: "content-section content-section__bordered border-1-20 profile-section no-margin-top",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditDetails === false) ? [_vm._v("User details")] : [_vm._v("Edit user details")]], 2), _vm._v(" "), (_vm.canEditDetails === false) ? _c('button', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditDetails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                      c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                      L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                      l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n            Edit\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element featured-image"
  }, [_c('div', {
    staticClass: "user-featured-image"
  }, [_c('span', {
    staticClass: "form-label color-2-63"
  }, [_vm._v("Profile image")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploaded && _vm.canEditDetails === true),
      expression: "!isThumbnailFileUploaded && canEditDetails === true"
    }],
    staticClass: "form-label color-2-63 form-label--file-upload",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail",
      "name": "Image",
      "data-vv-as": "\"Image\"",
      "value.sync": "user.personal.image",
      "disabled": _vm.canEditDetails === false
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploaded && _vm.canEditDetails === false),
      expression: "!isThumbnailFileUploaded && canEditDetails === false"
    }],
    staticClass: "user-featured-image-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-user fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "user",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0\n                           224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2\n                           288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    }
  })])]), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.user.personal.image + ')'
    }),
    attrs: {
      "id": "thumbnailFilePreview"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploaded && _vm.canEditDetails === true) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeThumbnail
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.first_name),
      expression: "user.personal.first_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "id": "new-user-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.user.personal.first_name)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-surname"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.last_name),
      expression: "user.personal.last_name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "id": "new-user-surname",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.user.personal.last_name)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.email),
      expression: "user.personal.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.user.personal.email)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.phone),
      expression: "user.personal.phone"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-user-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.user.personal.phone)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-role"
    }
  }, [_vm._v("User type (role)")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false || (_vm.getUserRole !== 'gm' && _vm.getUserRole !== 'ca' && _vm.getUserRole !== 'ta'),
      "searchable": true,
      "options": _vm.getRolesForSelect,
      "data-vv-name": "User type",
      "name": "User type",
      "id": "new-user-company-role"
    },
    on: {
      "keyup": _vm.fieldChange
    },
    model: {
      value: (_vm.user.personal.role),
      callback: function($$v) {
        _vm.$set(_vm.user.personal, "role", $$v)
      },
      expression: "user.personal.role"
    }
  }), _vm._v(" "), (this.errors.has('User type')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('User type')))]) : _vm._e()], 1), _vm._v(" "), (this.isStakeholder === true) ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-stakeholder_type"
    }
  }, [_vm._v("Stakeholder type")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.stakeholder_type),
      expression: "user.personal.stakeholder_type"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Stakeholder type'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "data-vv-name": "Stakeholder type",
      "name": "Stakeholder type",
      "id": "new-user-company-stakeholder_type"
    },
    domProps: {
      "value": (_vm.user.personal.stakeholder_type)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "stakeholder_type", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-name"
    }
  }, [_vm._v("Company name")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': (_vm.user.personal.role && _vm.user.personal.role.slug === 'gm')
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false || (_vm.user.personal.role && _vm.user.personal.role.slug === 'gm'),
      "searchable": true,
      "options": _vm.getCompaniesForSelect,
      "data-vv-name": "Company name",
      "name": "Company name",
      "id": "new-user-company-name"
    },
    on: {
      "keyup": _vm.fieldChange
    },
    model: {
      value: (_vm.user.personal.company),
      callback: function($$v) {
        _vm.$set(_vm.user.personal, "company", $$v)
      },
      expression: "user.personal.company"
    }
  }), _vm._v(" "), (this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-function"
    }
  }, [_vm._v("Function")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.function),
      expression: "user.personal.function"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Function'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-user-company-function",
      "name": "Function"
    },
    domProps: {
      "value": (_vm.user.personal.function)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "function", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Function')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Function')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-title"
    }
  }, [_vm._v("Job title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.job_title),
      expression: "user.personal.job_title"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Job title'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-user-company-title",
      "name": "Job title"
    },
    domProps: {
      "value": (_vm.user.personal.job_title)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "job_title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Job title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Job title')))]) : _vm._e()])]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-id"
    }
  }, [_vm._v("User id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.id),
      expression: "user.personal.id"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'is-blocked': _vm.canEditDetails,
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "data-lpignore": "true",
      "id": "new-user-id"
    },
    domProps: {
      "value": (_vm.user.personal.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "id", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditDetails) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditDetails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProfileDetails()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "userPassword",
    staticClass: "content-section content-section__bordered border-1-20 profile-section",
    class: [{
      'content-section__closed': _vm.canEditPassword === false
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "password-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditPassword === false) ? [_vm._v("User password")] : [_vm._v("Edit user password")]], 2), _vm._v(" "), (_vm.canEditPassword === false) ? _c('button', {
    staticClass: "edit-password edit-password-custom border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditPassword()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                      c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                      L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                      l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n            Edit\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canEditPassword) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-password-edit"
    }
  }, [_vm._v("New password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.plainPassword.first),
      expression: "user.personal.plainPassword.first"
    }],
    ref: "passwordInput",
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.passwordError
    }],
    attrs: {
      "disabled": _vm.canEditPassword === false,
      "data-lpignore": "true",
      "id": "new-password-edit",
      "type": "password",
      "name": "New password"
    },
    domProps: {
      "value": (_vm.user.personal.plainPassword.first)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal.plainPassword, "first", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('New password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('New password')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "retype-password"
    }
  }, [_vm._v("Retype new password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:passwordInput'),
      expression: "'required|confirmed:passwordInput'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.plainPassword.second),
      expression: "user.personal.plainPassword.second"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.passwordError
    }],
    attrs: {
      "disabled": _vm.canEditPassword === false,
      "data-lpignore": "true",
      "type": "password",
      "id": "retype-password",
      "name": "Retype new password",
      "data-vv-as": "Retype new password"
    },
    domProps: {
      "value": (_vm.user.personal.plainPassword.second)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal.plainPassword, "second", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Retype new password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Retype new password')))]) : _vm._e()])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.canEditPassword) ? _c('div', {
    staticClass: "update-data update-data__password"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-password",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditPassword()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-password",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProfilePassword()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    ref: "userData",
    staticClass: "content-section consent-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "password-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("User data")]), _vm._v(" "), _c('div', {
    staticClass: "consent-data",
    class: this.consentStatus === 1 ? 'consent-given' : 'consent-not-given'
  }, [(this.consentStatus === 1) ? [_vm._v("\n              User provided their consent to store and process their data under the GDPR settings on " + _vm._s(this.convertDate(this.consentDate, '.')) + ".\n            ")] : [(this.consentDate) ? [_vm._v("\n                User withdrawn their consent to allow us to use their data under the GDPR settings on " + _vm._s(this.convertDate(this.consentDate, '.')) + ". "), _c('br'), _vm._v("\n                User has to provide consent so he can use all the website functionalities.\n              ")] : [_vm._v("\n                User haven't provided yet with consent to store and use their data, under the GDPR settings."), _c('br'), _vm._v("\n                User has to provide consent so they can use all the website functionalities.\n              ")]]], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-helper-text color-2-63"
  }, [_vm._v("\n              The new password can't be the same as the old password."), _c('br'), _vm._v("\n              Please use a strong password. It must contain at least 9 characters that include capital letters, lower case letters and numbers.\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2eea876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/EditUser.vue
// module id = 1046
// module chunks = 0